module.exports = {
	data() {
		return {
			errors: {},
			maps: {
            	location: null,
            	address: '',
            	map: null,
            	bounds: null,
            	geocoder: null,
            	autocomplete: null,
            	directionsService: null,
            	infowindow: null,
            	markers: [],
            	directionsRenderers: [],
            	shouldUpdateBounds: false
            },
            mobileFilterActive: false,
            updatingFilters: false,
            updatingMap: false,
            defaultPinSvgPath: 'M0 11.0742C0 4.92188 5.03906 0 11.25 0C17.4609 0 22.5 4.92188 22.5 11.0742C22.5 18.0469 15.4688 26.4258 12.5391 29.5898C11.8359 30.3516 10.6641 30.3516 9.96094 29.5898C7.03125 26.4258 0 18.0469 0 11.0742ZM11.25 15C13.3008 15 15 13.3008 15 11.25C15 9.19922 13.3008 7.5 11.25 7.5C9.19922 7.5 7.5 9.19922 7.5 11.25C7.5 13.3008 9.19922 15 11.25 15Z',
            hoverPinSvgPath: 'M0 14.7656C0 6.5625 6.71875 0 15 0C23.2812 0 30 6.5625 30 14.7656C30 24.0625 20.625 35.2344 16.7188 39.4531C15.7812 40.4688 14.2188 40.4688 13.2812 39.4531C9.375 35.2344 0 24.0625 0 14.7656ZM15 20C17.7344 20 20 17.7344 20 15C20 12.2656 17.7344 10 15 10C12.2656 10 10 12.2656 10 15C10 17.7344 12.2656 20 15 20Z',
            clusterPinSvgPath: 'M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z',
            pinIcons: {},
            gettingLocation: false
		}
	},

	watch: {
		mobileFilterActive(val) {
			if (val) {
				let props = Object.keys(this.temp);

				for (let i=0; i<props.length; i++) {
					Vue.set(this.temp, props[i], this.query[props[i]]);
				}
			}
		}
	},

	computed: {
		placeIds() {
			return this.results.posts.map((place) => { return place.meta.place_id });
		},

		agronomistSlug() {
			// Named param works when the route definition matches exactly
			if (this.$route.params.agronomist) return this.$route.params.agronomist;

			// Otherwise derive from the path relative to the map's base path,
			// so this works regardless of where the map page sits in the hierarchy
			const base = agronomist.mapPagePath;
			const path = this.$route.path;
			if (path.startsWith(base) && path.length > base.length) {
				const remainder = path.slice(base.length).replace(/\/$/, '');
				if (remainder && !remainder.includes('/')) return remainder;
			}
			return null;
		}
	},

	created() {
		//
	},

	methods: {
		/**
		 * Returns a promise to GET a request (for public routes)
		 *
		 * @param  string  url  The URL to get
		 */
		getData(url = '') {
			return fetch(url, {
				headers: {
					'Accept': 'application/json'
				},
				credentials: 'same-origin'
			})
			.then(this.handleCommonResponseErrors)
			.then(response => response.json())
			.catch(error => console.log(error))
		},

		/**
		 * Returns a promise to POST a request
		 *
		 * @param  string  url     The URL to post
		 * @param  JSON    data    The JSON data to include
		 * @param  string  method  Type of request
		 */
		postJson(url = '', data = {}, method = 'POST') {
			return fetch(url, {
				method: method,
				body: JSON.stringify(data),
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json; charset=utf-8'
				},
				credentials: 'same-origin'
			})
			.then(response => response.json())
			.then(this.handleCommonResponseErrors)
			.catch(error => console.log(error));
		},

		/**
		 * Handle responses when the user is no longer authorized (session expired)
		 */
		handleCommonResponseErrors(response) {
			return response;
		},

		/**
		 * Listen to filter trigger clicks
		 */
		handleFilterTriggers() {
			var self = this;

			//Handle trigger clicks (easier with script than vue)
            $('.trigger .button').click(function(e) {
                //If this is currently active, close it
                if ($(this).parent().hasClass('active')) {
                    $(this).closest('.trigger').removeClass('active');
                    $('.inline-modal-overlay').removeClass('active');
                    //$('body').removeClass('no-scroll');
                }
                //If there are other guys open, close them
                //Open this one
                else {
                    $('.trigger.active').removeClass('active');

                    $(this).closest('.trigger').addClass('active');
                    $('.inline-modal-overlay').addClass('active');
                }
            });

            //Close popup when a thing is clicked
            $('.trigger .popup li').click(function(e) {
            	window.setTimeout(() => {
	                //Now close the modal
	                $(this).closest('.trigger').removeClass('active');
	                $('.inline-modal-overlay').removeClass('active');
            	}, 200);
            });

            //If the background is clicked, close the filtro
            $('.inline-modal-overlay').click(function(e) {
            	$('.trigger').removeClass('active');
            	$('.inline-modal-overlay').removeClass('active');
                $('body').removeClass('no-scroll');
            });
		},

		/**
		 * Listen to info window link clicks
		 */
		handleInfoWindowClicks() {
			var self = this;

			//View cluster clicks
			$(document).on('click', 'a.view-marker-group', function(e) {
				e.preventDefault();

				//Figure out the place ID
				let place_id = $(this).attr('data-place-id');

				self.navigateToGroup(place_id);
			});

			//View profile clicks
			$(document).on('click', 'a.view-agronomist-profile', function(e) {
				e.preventDefault();

				//Figure out the slug
				let slug = $(this).attr('data-slug');

				self.navigateToProfile(slug);
			});

			$(document).on('click', 'a.view-agronomist-contact-form', function(e) {
				e.preventDefault();

				//Figure out the slug
				let slug = $(this).attr('data-slug');

				self.navigateToProfile(slug, 'contact');
			});
		},

		/**
		 * Format kilometers from a float
		 *
		 * @param  float  distance  A distance in kilometers
		 *
		 * @return string  			The formatted distance
		 */
		formatKM(distance) {
			return Math.ceil(distance)+' KM';
		},

		initGoogle() {
			//Init geocoder and fill out address
            this.maps.geocoder = new google.maps.Geocoder();

            // this.geocodeLocation();

            //Init the autocomplete
            let addressField = document.getElementById('address');

            //Submit on enter
            this.pacSelectFirst(addressField);

            //Init
            this.maps.autocomplete = new google.maps.places.Autocomplete(
                addressField,
                {
                    componentRestrictions: {'country': 'ca'},
                    fields: ['formatted_address', 'geometry', 'place_id']
                }
            );

            //Listen for address change
            this.maps.autocomplete.addListener('place_changed', ((e) => {
                let place = this.maps.autocomplete.getPlace();

                if (place) {
                	this.navigateToLocation(place.geometry.location.lat(), place.geometry.location.lng(), place.formatted_address, 10);
                }
            }));

            //Create infowindow
            this.maps.infowindow = new google.maps.InfoWindow({
            	content: ''
            });

            //Track its marker
            this.maps.infowindow.marker = null;

            //Listen for mouse events (awkwardly through jQuery)
            $(document).on('mouseover', '.gm-style-iw-t', () => {
            	google.maps.event.trigger(this.maps.infowindow.marker, 'mouseover');
            });

            $(document).on('mouseout', '.gm-style-iw-t', () => {
            	google.maps.event.trigger(this.maps.infowindow.marker, 'mouseout');
            });
		},

		initMap() {
			let self = this;

			//Don't draw the map if it already is drawn
			if (this.maps.map) return;

			//Default values
			let zoom = this.maps.location ? 10 : 4;
			let lat = this.maps.location && this.maps.location.lat ? this.maps.location.lat : 60;
			let lng = this.maps.location && this.maps.location.lng ? this.maps.location.lng : -105;

			if (this.$route.query.z && this.$route.query.z > 0) {
				zoom = parseInt(this.$route.query.z);
			}

			//Can't draw the map if we don't have location
			// if (!this.maps.location || !this.maps.location.lat || !this.maps.location.lng) return;

			//Draw the map, centered on current location
			this.maps.map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                center: {
                    lat: lat,
                    lng: lng
                },
                mapTypeControl: false,
                streetViewControl: false,
                styles: agronomist && agronomist.map_style && agronomist.map_style.length ? JSON.parse(agronomist.map_style) : []
            });

            //Add listener for map bounds changing
            google.maps.event.addListener(this.maps.map, 'center_changed', function() {
            	self.handleMapMovement();
            });

            google.maps.event.addListener(this.maps.map, 'zoom_changed', function() {
            	self.handleMapMovement();
            });
		},

		handleMapMovement() {
			if (this.updatingMap) return;

			//Show the seach area button
			this.showSearchHere = true;
		},

		searchHere() {
			//Hide the search here
			this.showSearchHere = false;

			let center = this.maps.map.getCenter();
			let zoom = this.maps.map.getZoom();

			this.navigateToLocation(center.lat(), center.lng(), '', zoom);
		},

		updateMap(fitMapToBounds = false) {
			//Set flag
			this.updatingMap = true;

			let self = this;
			let combos = {};

			//Hoverintent?
			let maybeOpenWindow = false;
			let maybeCloseWindow = false;
			let timer = null;

			this.clearMarkers();

			//Update zoom?
			if (this.$route.query.z && this.$route.query.z > 0) {
				let zoom = parseInt(this.$route.query.z);

				if (zoom != this.maps.map.getZoom()) {
					this.maps.map.setZoom(zoom);
				}
			}

			if (this.results.posts.length) {
				this.maps.bounds = new google.maps.LatLngBounds();

				this.results.posts.forEach((place) => {
					//See if this is a combo pin
					if (place.meta.place_id && this.placeIds.indexOf(place.meta.place_id) != this.placeIds.lastIndexOf(place.meta.place_id)) {
						//Initialize combos if needed
						if (!combos[place.meta.place_id]) {
							combos[place.meta.place_id] = [];
						}

						//Put it away in the combos array
						combos[place.meta.place_id].push(place);

						//On to the next place
						return;
					}

					//Figure out the pin situation
					let pin = this.pinIcons.default;

					if (this.pinIcons[place.profile_type_id]) {
						pin = this.pinIcons[place.profile_type_id];
					}

					let pinArgs = {
						map: this.maps.map,
						position: new google.maps.LatLng(place.meta.lat, place.meta.lng),
						refersTo: place,
						icon: pin.icon
					};

					if (pin.label && pin.label.text) {
						pinArgs.label = pin.label;
					}

					//Draw the marker
					let marker = new google.maps.Marker(pinArgs);

					//Store default icon so setDefaultPin can restore it
					marker._defaultIcon = pinArgs.icon;

					//Save marker reference on place
					place.marker = marker;

					this.maps.bounds.extend(marker.position);
					this.maps.markers.push(marker);

					//Event listeners
					google.maps.event.addListener(marker, 'mouseover', function() {
						//Set the intent
						maybeOpenWindow = true;

						//Clear any existing timers
						if (timer) {
							clearTimeout(timer);
						}

						//Set the timer
						timer = setTimeout(() => {
							if (maybeOpenWindow) {
								self.showInfowindow(this);
								maybeOpenWindow = false;
							}
						}, 100);
					});

					google.maps.event.addListener(marker, 'mouseout', function() {
						//Set the intent
						maybeCloseWindow = true;

						//Clear any existing timers
						if (timer) {
							clearTimeout(timer);
						}

						//Set the timer
						timer = setTimeout(() => {
							if (maybeCloseWindow) {
								self.hideInfowindow(this);
								maybeCloseWindow = false;
							}
						}, 300);
					});

					google.maps.event.addListener(marker, 'click', function() {
						//router push
						self.navigateToProfile(this.refersTo.slug);
					});

					//If this is the active route, hover the marker
					if (this.agronomistSlug && this.agronomistSlug == place.slug) {
						this.setHoverPin(marker);
					}
				});

				//Now let's deal with the combo pins
				for (place_id in combos) {
					//Figure out the pin
					let pin = this.pinIcons.cluster;

					//Set the correct number label
					if (!agronomist.cluster_pin_icon_unicode) {
						pin.label.text = combos[place_id].length.toString();
					}

					//Other pin info
					let pinArgs = {
						map: this.maps.map,
						position: new google.maps.LatLng(combos[place_id][0].meta.lat, combos[place_id][0].meta.lng),
						refersTo: combos[place_id],
						icon: pin.icon,
						label: pin.label
					};

					//Draw the marker
					let marker = new google.maps.Marker(pinArgs);

					//Store default icon so setDefaultPin can restore it
					marker._defaultIcon = pinArgs.icon;

					let hoverThePin = false;

					//Save marker reference on places
					combos[place_id].forEach((place) => {
						place.marker = marker;

						if (this.agronomistSlug && this.agronomistSlug == place.slug) {
							hoverThePin = true;
						}
					});

					this.maps.bounds.extend(marker.position);
					this.maps.markers.push(marker);

					//Event listeners
					google.maps.event.addListener(marker, 'mouseover', function() {
						//Set the intent
						maybeOpenWindow = true;

						//Clear any existing timers
						if (timer) {
							clearTimeout(timer);
						}

						//Set the timer
						timer = setTimeout(() => {
							if (maybeOpenWindow) {
								self.showInfowindow(this, true);
								maybeOpenWindow = false;
							}
						}, 100);
					});

					google.maps.event.addListener(marker, 'mouseout', function() {
						//Set the intent
						maybeCloseWindow = true;

						//Clear any existing timers
						if (timer) {
							clearTimeout(timer);
						}

						//Set the timer
						timer = setTimeout(() => {
							if (maybeCloseWindow) {
								self.hideInfowindow(this, true);
								maybeCloseWindow = false;
							}
						}, 300);
					});

					google.maps.event.addListener(marker, 'click', function() {
						//router push
						self.navigateToGroup(this.refersTo[0].meta.place_id);
					});

					//If this is an active query, hover the marker
					if ((this.$route.query.place_id && place_id == this.$route.query.place_id) || hoverThePin) {
						this.setHoverPin(marker);
					}
				}

				//Fit map to new bounds, if needed
				if (fitMapToBounds) {
					this.maps.map.fitBounds(this.maps.bounds);
				}
			}

			//Okiedokiesmokie
			this.updatingMap = false;
		},

		updateMapCenter() {
			if (!this.maps.map) return;

			//Flag
			this.updatingMap = true;

			//Center
			this.maps.map.setCenter(new google.maps.LatLng(this.$route.query.lat, this.$route.query.lng));

			//Zoom
			if (this.$route.query.z && this.$route.query.z > 0) {
				this.maps.map.setZoom(parseInt(this.$route.query.z));
			}

			//Unflag
			this.updatingMap = false;
		},

		updateBounds() {
			//Adjust map bounds
			window.setTimeout(() => {
				if (this.maps.map) {
					this.maps.map.fitBounds(this.maps.bounds);
				}
			}, 400);
		},

		clearMarkers() {
			if (this.maps.markers.length) {
				this.maps.markers.forEach((marker) => {
					marker.setMap(null);
				});

				this.maps.markers = [];
			}
		},

		findUserLocation() {
			this.gettingLocation = true;

			this.requestUserLocation(); //Needs HTTPS so not working locally
		},

		requestUserLocation() {
			this.gettingLocation = true;
			if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(((position) => {
                	this.getGeocodedAddress(position.coords.latitude, position.coords.longitude);
                }),
                ((error) => {
                	this.locateIP();
                }),
                {
                	maximumAge: 0,
                	enableHighAccuracy: false,
                	timeout: 5000
                });
            }
            else {
            	this.locateIP();
            }
		},

		locateIP() {
			this.initMap();

			this.gettingLocation = false;
		},

		getGeocodedAddress(lat, lng) {
			let address = '';

			this.navigateToLocation(lat, lng, address, 10);

			/**
			 * Avoid geocoding to prevent unneeded Google Maps API calls
			 */
			return;

			if (lat && lng) {
				this.maps.geocoder.geocode({'location': {lat: lat, lng: lng}}, ((results, status) => {
					if (status == 'OK') {
						let city = ''; let province = '';

	                    results[0].address_components.some((component) => {
	                    	if (component.types.indexOf('locality') >= 0) {
	                    		city = `${component.long_name}, `;
	                    	}
	                    	else if (component.types.indexOf('administrative_area_level_1') >= 0) {
	                    		province = component.long_name;
	                    	}
	                    	else if (component.types.indexOf('county') >= 0) {
	                    		province = component.long_name
	                    	}

	                    	if (city.length && province.length) {
	                    		return;
	                    	}
	                    });

	                    address = city+province;
					}

					this.gettingLocation = false;

					this.navigateToLocation(lat, lng, address, 10);
				}));
			}
		},

		geocodeLocation() {
			/**
			 * Avoid geocoding to prevent unneeded Google Maps API calls
			 */
			return;

			if (this.maps.location && this.maps.location.lat && this.maps.location.lng) {
				this.maps.geocoder.geocode({'location': this.maps.location}, ((results, status) => {
	                if (status == 'OK') {
	                    let city = ''; let province = '';

	                    results[0].address_components.some((component) => {
	                    	if (component.types.indexOf('locality') >= 0) {
	                    		city = `${component.long_name}, `;
	                    	}
	                    	else if (component.types.indexOf('administrative_area_level_1') >= 0) {
	                    		province = component.long_name;
	                    	}
	                    	else if (component.types.indexOf('county') >= 0) {
	                    		province = component.long_name
	                    	}

	                    	if (city.length && province.length) {
	                    		return;
	                    	}
	                    });

	                    this.maps.address = city+province;
	                }
	            }));
			}
			else {
				this.maps.address = '';
			}
		},

		navigateToLocation(lat, lng, address = '', zoom = '') {
			//See if the values are different than current
			if (this.$route.query.lat == lat && this.$route.query.lng == lng) return;

			let query = {
				lat: Number.parseFloat(lat).toFixed(5),
				lng: Number.parseFloat(lng).toFixed(5)
			};

			if (address) {
				query.address = address;
			}

			//Set the zoom level
			if (zoom) {
				query.z = zoom;
			}
			else if (this.maps.map) {
				query.z = this.maps.map.getZoom();
			}
			else {
				query.z = this.maps.location ? 10 : 4;
			}

			this.$router.push({ path: this.$route.path, query: query});
		},

		navigateToGroup(place_id) {
			//See if the values are different than current
			if (this.$route.query.place_id == place_id && !this.agronomistSlug) return;

			//Update the query place_id
			let query = Object.assign({}, this.$route.query);
			query.place_id = place_id;

			//Navigate
			this.$router.push({ path: agronomist.mapPagePath, query: query});
		},

		navigateToProfile(slug, hash = '') {
			//See if the values are different than current
			if (this.agronomistSlug == slug) return;

			//Update the path
			let path = agronomist.mapPagePath + slug + '/';

			if (hash.length) {
				path += '#'+hash;
			}

			//Change the query to remove place_id if not applicable to this profile
			let query = Object.assign({}, this.$route.query);

			if (query.place_id) {
				let removePlaceId = true;

				//Loop through the markers, looking for clusters, and see if we should actually keep the place ID
				this.maps.markers.forEach((marker) => {
					if (Array.isArray(marker.refersTo)) {
						let matches = marker.refersTo.filter(place => place.slug == slug);

						//If the one we are navigating to is the same place_id as the active place_id, it can stay
						if (matches.length) {
							removePlaceId = false;
						}
					}
				});

				//If we didn't meet criteria to keep it, then remove the place_id
				if (removePlaceId) {
					delete query.place_id;
				}
			}

			//Navigate
			this.$router.push({ path: path, query: query});
		},

		navigateToDefault() {
			this.$router.push({ path: agronomist.mapPagePath });
		},

		loadPage(page) {
			//Update the query page
			let query = Object.assign({}, this.$route.query);
			query.pg = page;

			//Unset cluster when changing pages (just in case)
			if (query.page_id) {
				delete query.page_id;
			}

			//Navigate
			this.$router.push({ path: this.$route.path, query: query});
		},

		loadFilter(prop, values) {
			//See if values are different than current query
			if (this.query[prop] == values) return;

			//update the query prop
			let query = Object.assign({}, this.$route.query);
			query[prop] = values.join(',');

			//Delete the prop if we have no values
			if (!values.length) {
				delete query[prop];
			}

			//If we have a page, delete it
			if (query.pg) {
				delete query.pg;
			}

			//Unset cluster when changing types (just in case)
			if (query.page_id) {
				delete query.page_id;
			}

			//Navigate
			this.$router.push({ path: this.$route.path, query: query});
		},

		/**
		 * After changing pages especially, but whenever a new set of results loads
		 * If you are scrolled lower than the top of the results, scroll back up to it
		 */
		scrollUp() {
			$('html, body, .results').animate({ scrollTop: 0 }, 300);
		},

		/**
		 * Allow google autocomplete to submit by pressing enter
		 *
		 * @see https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter/11703018#11703018
		 */
		pacSelectFirst(input) {
			// store the original event binding function
	        var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

	        function addEventListenerWrapper(type, listener) {
	            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
	            // and then trigger the original listener.
	            if (type == "keydown") {
	                var orig_listener = listener;
	                listener = function(event) {
	                    var suggestion_selected = $(".pac-item-selected").length > 0;
	                    if (event.which == 13 && !suggestion_selected) {
	                        var simulated_downarrow = $.Event("keydown", {
	                            keyCode: 40,
	                            which: 40
	                        });
	                        orig_listener.apply(input, [simulated_downarrow]);
	                    }

	                    orig_listener.apply(input, [event]);
	                };
	            }

	            _addEventListener.apply(input, [type, listener]);
	        }

	        input.addEventListener = addEventListenerWrapper;
	        input.attachEvent = addEventListenerWrapper;
		},

		/**
		 * Generate pin icons
		 */
		setPinIcons() {
			this.setPinIcon({ term_id: 'default', meta: { pin_color: '1a6135' } });

			this.pinIcons['cluster'] = {
				icon: this.getClusterPinIcon('#1a6135'),
				label: {
					text: '',
					fontFamily: 'Open Sauce Sans',
					fontSize: '12px',
					color: 'white',
					fontWeight: '700',
					defaultFontSize: '12px',
					hoverFontSize: '15.6px'
				}
			};
		},

		getDefaultPinIcon(color = '#00783F') {
			const svg = `<svg width="23" height="31" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${this.defaultPinSvgPath}" fill="${color}"/></svg>`;
			return {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
				scaledSize: new google.maps.Size(23, 31),
				anchor: new google.maps.Point(11, 31),
				labelOrigin: new google.maps.Point(11, 11)
			};
		},

		getClusterPinIcon(color = '#1a6135') {
			const svg = `<svg width="23" height="31" viewBox="0 0 384 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${this.clusterPinSvgPath}" fill="${color}"/></svg>`;
			return {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
				scaledSize: new google.maps.Size(23, 31),
				anchor: new google.maps.Point(12, 31),
				labelOrigin: new google.maps.Point(12, 12)
			};
		},

		getClusterHoverPinIcon() {
			const svg = `<svg width="30" height="41" viewBox="0 0 384 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${this.clusterPinSvgPath}" fill="#B0852D"/></svg>`;
			return {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
				scaledSize: new google.maps.Size(30, 41),
				anchor: new google.maps.Point(15, 41),
				labelOrigin: new google.maps.Point(15, 15)
			};
		},

		getHoverPinIcon() {
			const svg = `<svg width="30" height="41" viewBox="0 0 30 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${this.hoverPinSvgPath}" fill="#B0852D"/></svg>`;
			return {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
				scaledSize: new google.maps.Size(30, 41),
				anchor: new google.maps.Point(15, 41),
				labelOrigin: new google.maps.Point(15, 14)
			};
		},

		setPinIcon(type, fontFamily = "'Font Awesome 5 Pro'", fontSize = 14, doEval = true) {
			const color = type.meta.pin_color ? `#${type.meta.pin_color}` : '#00783F';
			const icon = this.getDefaultPinIcon(color);

			//Define the label
			let label = {
				text: ''
			};

			if (type.meta.pin_icon && type.meta.show_pin_icon == 'yes') {
				label = {
					text: doEval ? eval("'\\u" + type.meta.pin_icon + "'") : type.meta.pin_icon,
					fontFamily: fontFamily,
					fontSize: `${fontSize}px`,
					color: type.meta.pin_icon_color == 'light' ? 'white' : 'black',
					fontWeight: '700',
					defaultFontSize: `${fontSize}px`,
					hoverFontSize: `${fontSize * 1.3}px`
				};
			}

			this.pinIcons[type.term_id] = {
				icon,
				label
			};
		},

		showProfileType(type_id) {
			if (!type_id) {
				return 'no';
			}

			return this.types.find(t => t.term_id == type_id).meta.show_list_label == 'yes';
		},

		getProfileTypeStyles(type_id) {
			if (!type_id) {
				return '';
			}

			let type = this.types.find(t => t.term_id == type_id);

			return `background-color: #${type.meta.pin_color}1A; color: #${type.meta.pin_color};`
		},

		getProfileTypeIconClass(type_id) {
			if (!type_id) {
				return '';
			}

			return this.types.find(t => t.term_id == type_id).meta.pin_icon_class;
		},

		getProfileTypeLabel(type_id) {
			if (!type_id) {
				return '';
			}

			return this.types.find(t => t.term_id == type_id).name;
		},

		getProfileTypeShowContactForm(type_id) {
			//If we don't have a type_id, return 'no'
			if (!type_id) {
				return 'no';
			}

			return this.types.find(t => t.term_id == type_id).meta.show_contact_form;
		},

		showContactForm(place) {
			if (place && place.meta && place.meta.display_contact_form && place.meta.display_contact_form == 'default') {
				return this.getProfileTypeShowContactForm(place.profile_type_id);
			}

			return place.meta.display_contact_form;
		},

		setInfowindowContent(place) {
			let content = '<div class="infowindow-content"><div class="top">';

			//Name & designations
			content += `<p class="name-designations">${place.meta.full_name}`;

			//Company
			content += `<br/><span class="company">${this.parseEmployer(place.meta.current_employer)}</span></p>`;

			//Location
			if (place.meta.location) {
				let distance = place.meta.distance ? `<span class="distance">${place.meta.distance} KM</span>` : '';

				content += `<p class="location-distance"><span class="location">${place.meta.location}</span>${distance}</p>`;
			}

			//Actions
			if (place.meta.phone_number || place.meta.website_url || this.showContactForm(place) == 'yes') {
				content += '<div class="action-icons">';

				if (place.meta.website_url) {
					content += `<a href="${place.meta.website_url}" target="_blank" rel="noopener nofollow" title="View website"><svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33594 4.78125L1.57031 5.17969C1.75781 5.50781 2.08594 5.76562 2.46094 5.88281L3.82031 6.25781C4.21875 6.375 4.5 6.75 4.5 7.17188V8.10938C4.5 8.36719 4.64062 8.60156 4.875 8.69531C5.08594 8.8125 5.25 9.04688 5.25 9.30469V10.2188C5.25 10.5938 5.57812 10.8516 5.92969 10.7578C6.32812 10.6406 6.60938 10.3359 6.70312 9.96094L6.77344 9.70312C6.86719 9.30469 7.125 8.97656 7.47656 8.76562L7.66406 8.64844C8.01562 8.46094 8.25 8.08594 8.25 7.6875V7.47656C8.25 7.19531 8.10938 6.89062 7.89844 6.67969L7.82812 6.60938C7.61719 6.39844 7.3125 6.25781 7.03125 6.25781H6.02344C5.74219 6.25781 5.48438 6.21094 5.27344 6.07031L4.45312 5.60156C4.35938 5.55469 4.28906 5.46094 4.24219 5.34375C4.17188 5.13281 4.26562 4.875 4.47656 4.78125L4.61719 4.71094C4.78125 4.61719 4.94531 4.61719 5.10938 4.66406L5.67188 4.85156C5.85938 4.92188 6.07031 4.82812 6.1875 4.66406C6.28125 4.5 6.28125 4.28906 6.14062 4.14844L5.83594 3.75C5.60156 3.46875 5.60156 3.07031 5.83594 2.78906L6.21094 2.36719C6.42188 2.10938 6.44531 1.78125 6.28125 1.5L6.23438 1.40625C6.14062 1.40625 6.07031 1.38281 5.97656 1.38281C3.82031 1.38281 1.96875 2.8125 1.33594 4.78125ZM10.875 6.25781C10.875 5.41406 10.6406 4.59375 10.2422 3.89062L9.65625 4.125C9.28125 4.28906 9.09375 4.6875 9.21094 5.0625L9.60938 6.25781C9.67969 6.49219 9.89062 6.67969 10.1484 6.75L10.8281 6.91406C10.8516 6.70312 10.8516 6.49219 10.8516 6.25781H10.875ZM0 6.25781C0 4.125 1.125 2.15625 3 1.07812C4.85156 0 7.125 0 9 1.07812C10.8516 2.15625 12 4.125 12 6.25781C12 8.41406 10.8516 10.3828 9 11.4609C7.125 12.5391 4.85156 12.5391 3 11.4609C1.125 10.3828 0 8.41406 0 6.25781Z" fill="#4D5452"/></svg></a>`;
				}

				if (place.meta.phone_number) {
					content += `<a title="Phone agronomist" href="tel:${place.meta.phone_number}"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.84375 0.65625L4.78125 2.90625C4.94531 3.28125 4.85156 3.72656 4.52344 3.98438L3.375 4.94531C4.14844 6.58594 5.48438 7.92188 7.125 8.69531L8.08594 7.54688C8.34375 7.21875 8.78906 7.125 9.16406 7.28906L11.4141 8.22656C11.8594 8.39062 12.0703 8.88281 11.9531 9.32812L11.3906 11.3906C11.2734 11.7891 10.9219 12.0703 10.5 12.0703C4.6875 12.0703 0 7.38281 0 1.57031C0 1.14844 0.28125 0.796875 0.679688 0.679688L2.74219 0.117188C3.1875 0 3.67969 0.210938 3.84375 0.65625Z" fill="#4D5452"/></svg></a>`;
				}

				if (place.meta.email) {
					content += `<a title="Email agronomist" href="mailto:${place.meta.email}"><svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.125 0H10.875C11.4844 0 12 0.515625 12 1.125C12 1.5 11.8125 1.82812 11.5312 2.03906L6.44531 5.85938C6.16406 6.07031 5.8125 6.07031 5.53125 5.85938L0.445312 2.03906C0.164062 1.82812 0 1.5 0 1.125C0 0.515625 0.492188 0 1.125 0ZM0 2.625L5.08594 6.46875C5.625 6.86719 6.35156 6.86719 6.89062 6.46875L12 2.625V7.5C12 8.34375 11.3203 9 10.5 9H1.5C0.65625 9 0 8.34375 0 7.5V2.625Z" fill="#4D5452"/></svg></a>`;
				}

				content += '</div>';
			}

			content += '</div><div class="bottom">';

			//Permalink
			content += '<a class="view-agronomist-profile" data-slug="'+place.slug+'">View Profile</a>';

			//That's all
			content += '</div></div>';

			this.maps.infowindow.setContent(content);
		},

		setInfowindowClusterContent(place_id) {
			let content = '<div class="infowindow-content"><div class="bottom">';

			//Permalink
			content += '<a class="view-marker-group" data-place-id="'+place_id+'">View Group</a>';

			//That's all
			content += '</div></div>';

			this.maps.infowindow.setContent(content);
		},

		isValidEmailAddress(emailAddress) {
		    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
		    return pattern.test(emailAddress);
		},

		setDefaultPin(marker) {
			//Check route info before setting default pin?
			//Handle clusters vs single
			if (Array.isArray(marker.refersTo)) {
				let hoverThePin = false;

				//Check if pin is active
				marker.refersTo.forEach((place) => {
					if ((this.agronomistSlug && this.agronomistSlug == place.slug) || (this.$route.query.place_id && this.$route.query.place_id == place.meta.place_id)) {
						hoverThePin = true;
					}
				});

				if (hoverThePin) {
					//Don't change the pin
					return;
				}
			}
			//Handle single
			else if (this.agronomistSlug && marker.refersTo.slug == this.agronomistSlug) {
				//Don't change the pin
				return;
			}

			//Restore the stored default icon
			if (marker._defaultIcon) {
				marker.setIcon(marker._defaultIcon);
			}

			//Get the current marker label
			let label = marker.getLabel();

			//Adjust size if applicable
			if (label && label.defaultFontSize) {
				label.fontSize = label.defaultFontSize;

				marker.setLabel(label);
			}
		},

		setHoverPin(marker) {
			//Swap to the hover SVG icon — clusters use their own shape
			const hoverIcon = Array.isArray(marker.refersTo)
				? this.getClusterHoverPinIcon()
				: this.getHoverPinIcon();
			marker.setIcon(hoverIcon);

			//Get the current marker label
			let label = marker.getLabel();

			//Adjust size if applicable
			if (label && label.defaultFontSize) {
				label.fontSize = label.hoverFontSize;

				marker.setLabel(label);
			}
		},

		showInfowindow(marker, cluster = false) {
			//Don't re-show it
			if (this.maps.infowindow.marker == marker) return;

			//Reset the previously hovered marker before switching to avoid stuck hover states
			if (this.maps.infowindow.marker) {
				const prev = this.maps.infowindow.marker;
				this.setDefaultPin(prev);
				if (Array.isArray(prev.refersTo)) {
					prev.refersTo.forEach(place => { place.hovered = false; });
				} else {
					prev.refersTo.hovered = false;
				}
			}

			//hover pin
			this.setHoverPin(marker);

			//Handle cluster vs single
			if (cluster) {
				//result list hover
				marker.refersTo.forEach((place) => {
					place.hovered = true;
				});

				//update infowindow text
				this.setInfowindowClusterContent(marker.refersTo[0].meta.place_id);
			}
			else {
				//result list hover
				marker.refersTo.hovered = true;

				//Update infowindow text
				this.setInfowindowContent(marker.refersTo);
			}

			//Open infowindow
			this.maps.infowindow.open(this.maps.map, marker);

			//Track marker
			this.maps.infowindow.marker = marker;
		},

		hideInfowindow(marker, cluster = false) {
			//Default pin
			this.setDefaultPin(marker);

			//Handle cluster vs single
			if (cluster) {
				//result list unhover
				marker.refersTo.forEach((place) => {
					place.hovered = false;
				});
			}
			else {
				//result list unhover
				marker.refersTo.hovered = false;
			}

			//Close infowindow
			this.maps.infowindow.close();

			//Get outta here marker
			this.maps.infowindow.marker = null;
		},

		setDocumentTitle(prefix = '') {
			let title = agronomist.blogTitle;

			if (prefix.length) {
				title = `${prefix} – ${title}`;
			}

			//Update the document title
			document.title = title;
		},

		parseEmployer(employer = '') {
			return employer && employer.length ? employer : '';
		}
	}
};
